'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var variants = require('../variants-434e0406.js');
var index = require('../index-6f152094.js');
require('../lib-75591456.js');
require('tslib');
require('react');
require('classnames');
require('styled-components');
require('@prisjakt/design-tokens/light-theme-colors');



exports.BodyLargeText = variants.BodyLargeText;
exports.BodyMediumText = variants.BodyMediumText;
exports.BodySmallText = variants.BodySmallText;
exports.CaptionStrongText = variants.CaptionStrongText;
exports.CaptionText = variants.CaptionText;
exports.H1Text = variants.H1Text;
exports.H2Text = variants.H2Text;
exports.H3Text = variants.H3Text;
exports.H4Text = variants.H4Text;
exports.TitleMediumText = variants.TitleMediumText;
exports.TitleSmallText = variants.TitleSmallText;
exports.textProperties = variants.textProperties;
Object.defineProperty(exports, 'Behavior', {
	enumerable: true,
	get: function () { return index.Behavior; }
});
Object.defineProperty(exports, 'FontColor', {
	enumerable: true,
	get: function () { return index.FontColor; }
});
Object.defineProperty(exports, 'FontEmphasis', {
	enumerable: true,
	get: function () { return index.FontEmphasis; }
});
Object.defineProperty(exports, 'FontScale', {
	enumerable: true,
	get: function () { return index.FontScale; }
});
Object.defineProperty(exports, 'FontWeight', {
	enumerable: true,
	get: function () { return index.FontWeight; }
});
//# sourceMappingURL=variants.js.map
